<style lang="stylus">
    .mo-work-member-free
        box-shadow 0px 1px 6px 0px rgba(130, 162, 252, 0.7) !important

    .mo-work--worker-check
        width 30px
        height 30px

    .mo-newwork
        min-width 60px
        padding 30px 0
        svg
            width 60px
            height 60px
            margin 0 auto
            display block
        div
            text-align center
            margin 10px auto

    .test
        .mo-work--wrapper
            height 200px
            display flex
            align-items center
            justify-content space-around

            .mo-work--img
                min-height 60px
                max-height 100%
                max-width 100%
                margin 0 auto
                width auto

        .mo-work--text
            overflow hidden
            text-overflow ellipsis
            white-space nowrap
</style>

<template>
    <div class="mo-waterfall" :class="{ 'internal-waterfall': !internal }">
        <RightMenu
            v-show="reportMenu"
            :style="{ top: top + 'px', left: left + 'px' }"
            :menuList="[{ label: $t('report') }]"
            @handleClicks="report()"
        />
        <div class="mo-waterfall--grid-sizer" />
        <div class="mo-waterfall--gutter-sizer" />
        <!-- <div class="" v-if="type==='center'">

        </div> -->
        <div
            v-if="isOldVersion && type === 'center' && showAddTemp && internal && albumPageStatus == 'default'"
            class="mo-work"
            id="AddNewTemp"
            @click="addNewPage"
        >
            <div class="mo-work--wrapper mo-newwork">
                <iconSymbol name="add-newtemp"></iconSymbol>
                <div>
                    {{ $t("new") }}
                </div>
            </div>
        </div>
        <div
            v-for="(work, index) in works"
            :key="index"
            :class="{
                'mo-work-member-free': type == 'review' && work.member_free,
                test: $route.query.mode == 'b',
            }"
            class="mo-work"
            @contextmenu="showReport($event, work)"
        >
            <tplWork
                :type="type"
                :work="work"
                :index="index"
                @cancelCollect="cancelCollect"
                @openTemplate="openTemplate"
                @trackTemplate="trackTemplate"
            />
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    import { internal } from "@/public/utils/env";
    import RightMenu from "../RightMenu.vue";
    import { adonlineURL } from "@/public/utils/tool.js";

    @Component({
        components: {
            tplWork: () => (internal ? import("./tplWork.vue") : import("../en/tplWork.vue")),
            RightMenu,
        },
    })
    export default class TplWaterFall extends Vue {
        @Prop({
            type: Array,
            required: true,
        })
        works;
        @Prop({
            type: String,
            required: true,
        })
        type;

        isOperating = false;

        showAddTemp = true;

        cancelCollect(id) {
            this.$emit("cancelCollect", id);
        }

        setLibs() {
            if (!this.isPC && this.tagID == 0) {
                // 勾选全部，判断是否有记住设置, pc跳过
                let store = localStorage;
                let rememberStatus = store.getItem("rememberLib");
                if (parseInt(rememberStatus)) {
                    let libs = store.getItem("rememberLibList");
                    localStorage.setItem("libs", libs);
                } else if (this.libs.length > 0) {
                    localStorage.setItem("libs", JSON.stringify(this.libs));
                } else {
                    localStorage.setItem("libs", "[4, 373]");
                }
            } else {
                if (this.libs.length > 0) {
                    localStorage.setItem("libs", JSON.stringify(this.libs));
                } else {
                    localStorage.setItem("libs", "[4, 373]");
                }
            }
        }
        get isOldVersion() {
            if (!this.pcVersion) {
                return false;
            }
            let arr = this.pcVersion.split(".");
            if (arr[1] < 1 || arr[2] < 3) {
                return true;
            } else {
                return false;
            }
        }
        get pcVersion() {
            return this.$store.state.pcVersion;
        }
        get userInfo() {
            return this.$store.state.userInfo;
        }
        get libs() {
            return this.$store.state.tplCenter.libID;
        }
        get tagID() {
            return this.$store.state.tplCenter.tagID;
        }
        get albumPageStatus() {
            return this.$store.state.tplCenter.albumPageStatus;
        }
        addNewPage() {
            if (!this.isPC && !this.$validateLogin()) return;
            let ts: any = this;
            let maxAction = this.$store.state.appState;
            if (maxAction) {
                if (maxAction == "create") (<any>this).$edMessage.success(this.$t("create"));
                // else if(maxAction == 'share')
                //     (<any>this).$edMessage.success(this.$t('openTips'));
                return;
            }
            this.setLibs();
            if (this.isOperating) return;
            this.isOperating = true;
            // if (!this.userInfo) {
            //     ts.$bus.$emit("login")
            //     return
            // }
            let newTab: any;
            if (!this.isPC) {
                newTab = window.open(`${window.location.origin}${(<any>this.$router).options.base}app.html`, "");
            }

            // newTab.location.href = `${window.location.origin}/app.html?action=openfile`;
            // return;
            let list = [];
            let name = this.$t("newFile");

            if (this.isPC) {
                let libs = localStorage.getItem("libs");
                let track = localStorage.getItem("tagTrackArg");
                let paramForPc = {
                    name,
                    newPath: "",
                    libs,
                    type: "new",
                    track,
                    accessid: this.OSSAccessKeyId,
                };
                (<any>window).$qt.jsCallUploadData &&
                    (<any>window).$qt.jsCallUploadData(
                        JSON.stringify({
                            type: "S005_Select_Diagram_8",
                            action: "SL035_Select_Diagram",
                            label: JSON.stringify({ name: this.$store.state.workClassName }),
                        })
                    );
                (<any>window).$qt.jsCallCloudFileOperate(JSON.stringify(paramForPc));
                this.isOperating = false;
            } else {
                this.$store
                    .dispatch("getUserLimit", this.$store.state.publicStore.runPlatform)
                    .then((res) => {
                        if (res.data.is_over_limit) {
                            newTab.close();
                            this.$store.commit("toPublicStatus", {
                                type: "showUpgrade",
                                data: "fileNum",
                            });

                            this.isOperating = false;
                        } else {
                            this.$store.dispatch("getFloder", { prefix: "" }).then((res) => {
                                let folderList = res.data.data.folders || [];
                                let filesList = res.data.data.files || [];
                                filesList.map((item) => {
                                    let list = item.key.split("/");
                                    let name = list[list.length - 1];
                                    name = name.match(/(.*)\.eddx/) && name.match(/(.*)\.eddx/)[1];
                                    item.name = name;
                                });
                                filesList = filesList.filter((item) => {
                                    if (item.key.match(/.+eddx$/)) {
                                        return true;
                                    }
                                    return false;
                                });

                                filesList.forEach((file) => {
                                    let reg = new RegExp(`^${this.$t("newFile")}(\\d*)$`);
                                    let res = file.name && file.name.match(reg);
                                    if (res) {
                                        if (res[1]) {
                                            list.push(+res[1]);
                                        } else {
                                            list.push(0);
                                        }
                                    }
                                });
                                list = list.sort((a, b) => a - b);
                                if (list.includes(0)) {
                                    for (let i = 0; i < list.length; i++) {
                                        if (list[i] + 1 != list[i + 1]) {
                                            name = this.$t("newFile") + (list[i] + 1);
                                            break;
                                        }
                                    }
                                }

                                let keyName = `${this.userInfo.user_name}/Personal/${name}.eddx`;
                                let url = adonlineURL(
                                    `${window.location.origin}${(<any>this.$router).options.base}app.html?` +
                                        ts.$zipFileName(`obj=${keyName}`) +
                                        "#create"
                                );
                                newTab.location.href = url;
                                this.$store.commit("setAppState", "create");
                                let timer = setInterval(() => {
                                    try {
                                        newTab.name;
                                        newTab.name = keyName;
                                        if (!newTab.name) {
                                            this.$store.commit("setAppState", "");
                                            clearInterval(timer);
                                        }
                                        if (!newTab.location.hash) {
                                            this.$store.commit("setAppState", "");
                                            clearInterval(timer);
                                        }
                                    } finally {
                                    }
                                }, 1000);
                                this.$store.state.winobj[keyName] = newTab;
                                this.isOperating = false;
                            });
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        this.isOperating = false;
                    });
            }
        }
        get top() {
            return this.$store.state.layoutTop;
        }
        set top(v) {
            this.$store.commit("setState", {
                type: "layoutTop",
                data: v,
            });
        }
        get left() {
            return this.$store.state.layoutLeft;
        }
        set left(v) {
            this.$store.commit("setState", {
                type: "layoutLeft",
                data: v,
            });
        }
        get moveTop() {
            return this.top + 228;
        }
        get moveLeft() {
            return this.left + 100;
        }
        get folderMenuBoxShow() {
            return true;
        }
        get reportMenu() {
            return this.$store.state.reportMenu;
        }
        set reportMenu(data) {
            this.$store.commit("setState", {
                type: "reportMenu",
                data,
            });
        }
        reportWork: any;
        showReport(e, work) {
            if (this.type === "report") return;
            this.top = e.pageY;
            this.left = e.pageX;
            this.reportMenu = true;
            this.reportWork = work;
            // console.log(this.work.id == this.reportWorkID)
            // console.log(this.work)
            window.addEventListener("click", this.closeReportMenu);
            event.stopPropagation();
            event.preventDefault();
        }
        report() {
            // WsTrack('Community', "Report");
            // this.$track("Community", "Report");
            event.stopPropagation();
            event.preventDefault();
            if (!this.$validateLogin()) {
                this.closeReportMenu();
                return;
            }
            this.$store.commit("toActiveWork", this.reportWork);
            this.$store.commit("toTplCenter", {
                name: "previewContext",
                data: this.type,
            });
            this.$bus.$emit("setReportAlertValue", true, this.reportWork, this.params, this.closeReportMenu);
        }
        closeReportMenu() {
            this.reportMenu = false;
        }
        openTemplate(action) {
            this.$emit("openTemplate", action);
        }
        trackTemplate(action) {
            this.$emit("trackTemplate", action);
        }
        created() {
            this.showAddTemp = !new URLSearchParams(location.search.substr(1)).get("addTemp");
        }
        beforeDestroy() {
            this.showAddTemp = null;
            window.removeEventListener("click", this.closeReportMenu);
        }
    }
</script>

<i18n>
{
  "zh": {
    "new": "新建空白模板",
    "free": "免费",
    "vipFree": "会员免费",
    "newFile": "未命名文件",
    "space": "云空间已达上限， 删除文件或清理回收站",
    "like": "已点赞",
    "cancelLike": "已取消点赞",
    "collect": "已收藏",
    "cancelCollect": "已取消收藏",
    "notTem": "该分类下暂时还没有模板",
    "create": "正在创建文件中，请稍后再试",
    "openTips": "正在打开文件中，请稍后再试",
    "mindmaster": "一款更加专业的跨端思维导图工具",
    "mindmasterBtn": "立即访问",
    "search": "搜索",
    "noRes": "没有找到相关模板",
    "report": "举报"
  },
  "en": {
    "new": "New",
    "free": "Free",
    "vipFree": "VIP Free",
    "newFile": "Unnamed File",
    "space": "Space storage not enough, delete files or upgrade to premium version to solve it.",
    "like": "Liked",
    "cancelLike": "Remove Like",
    "collect": "Add to Favorites",
    "cancelCollect": "Remove from Favorites",
    "notTem": "There is no template for this category yet.",
    "create": "Creating file, please try again later.",
    "openTips": "Opening file, please try again later.",
    "mindmaster": "A Professional Cross-platform Mind Mapping Tool",
    "mindmasterBtn": "See Now",
    "search": "Search",
    "noRes": "Sorry, no templates found"
  },
  "fr": {
    "new": "Nouveau",
    "free": "Gratuit",
    "vipFree": "VIP gratuit",
    "newFile": "Fichier sans nom",
    "space": "L'espace cloud a atteint la limite supérieure, supprimer des fichiers ou nettoyer la corbeille",
    "like": "Aimé",
    "cancelLike": "N'a pas aimé",
    "collect": "Favoris",
    "cancelCollect": "Favori annulé",
    "notTem": "Il n'y a pas de modèle pour cette catégorie",
    "create": "Création du fichier, veuillez réessayer plus tard",
    "openTips": "Ouverture du fichier, veuillez réessayer plus tard",
    "mindmaster": "Un outil de cartographie mentale plus professionnel",
    "mindmasterBtn": "Visitez maintenant",
    "search": "Chercher",
    "noRes": "Aucun modèle associé trouvé"
  },
  "de": {
    "new": "Neu",
    "free": "Kostenlos",
    "vipFree": "VIP Kostenlos",
    "newFile": "Unbenannte Datei",
    "space": "Speicherplatz nicht ausreichend, Dateien löschen oder auf Premium-Version aktualisieren, um das Problem zu lösen",
    "like": "Liked",
    "cancelLike": "Like entfernen",
    "collect": "Zu Favoriten hinzufügen",
    "cancelCollect": "Von Favoriten entfernen",
    "notTem": "Es gibt noch keine Vorlage für diese Kategorie",
    "create": " Datei wird erstellt, versuchen Sie es später erneut",
    "openTips": " Datei wird geöffnet, versuchen Sie es später erneut",
    "mindmaster": "Ein professionelles plattformübergreifendes Mind Mapping-Tool",
    "mindmasterBtn": "Jetzt besuchen",
    "search": "Suchen",
    "noRes": "Entschuldigung, keine Vorlage gefunden",
    "report": "Melden"
  },
  "jp": {
    "new": "新着",
    "free": "無料",
    "vipFree": "メンバーは無料",
    "newFile": "名前のないファイル",
    "space": "クラウドスペースがいっぱいになりました。ファイルを削除するかごみ箱をクリアしてください",
    "like": "いいね",
    "cancelLike": "いいねをキャンセル",
    "collect": "お気に入りに追加",
    "cancelCollect": "お気に入りをキャンセルしました",
    "notTem": "このカテゴリのテンプレートはありません",
    "create": "ファイルを作成しています。しばらくしてからもう一度お試しください",
    "openTips": "ファイルを開いています。しばらくしてからもう一度お試しください",
    "mindmaster": "プラットフォームで作業できるより専門的なマインドマッピングツール",
    "mindmasterBtn": "今すぐアクセス",
    "search": "検索",
    "noRes": "関連するテンプレートが見つかりませんでした",
    "report": "レポート"
  },
  "es": {
    "new": "Nuevo",
    "free": "Gratis",
    "vipFree": "VIP gratis",
    "newFile": "Archivo sin nombre",
    "space": "El espacio de almacenamiento no es suficiente, elimine archivos o actualice a la versión premium para resolverlo",
    "like": "Me gustó",
    "cancelLike": "Eliminar Me gusta",
    "collect": "Agregar a favoritos",
    "cancelCollect": "Eliminar de favoritos",
    "notTem": "Todavía no hay una plantilla para esta categoría.",
    "create": "Creando archivo, por favor intente nuevamente más tarde.",
    "openTips": "Abrir archivo, por favor intente nuevamente más tarde.",
    "mindmaster": "Una herramienta profesional de mapas mentales multiplataforma",
    "mindmasterBtn": "Ver ahora",
    "search": "Buscar",
    "noRes": "Lo sentimos, no se encontraron plantillas"
  },
  "it": {
    "new": "Nuovo",
    "free": "Gratuit",
    "vipFree": "VIP gratuito",
    "newFile": "File senza nome",
    "space": "Lo spazio nel cloud ha raggiunto il limite superiore, elimina i file o pulisci il cestino",
    "like": "Piace",
    "cancelLike": "Non mi è piaciuto",
    "collect": "Preferiti",
    "cancelCollect": "Rimuovi dai preferiti",
    "notTem": "Non esiste un modello per questa categoria",
    "create": "Creazione del file, riprova più tardi.",
    "openTips": "Apertura del file, riprova più tardi.",
    "mindmaster": "Uno strumento professionale per mappe mentali multipiattaforma",
    "mindmasterBtn": "Vedi ora",
    "search": "Cerca",
    "noRes": "Nessun modello correlato trovato"
  },
  "pt": {
    "new": "Novo",
    "free": "Gratuito",
    "vipFree": "VIP gratuito",
    "newFile": "Arquivo sem nome",
    "space": "Espaço de armazenamento insuficiente, delete arquivos ou atualize para a versão premium para resolvê-lo.",
    "like": "curtir",
    "cancelLike": "Remover das curtidas",
    "collect": "Adicionar aos favoritos",
    "cancelCollect": "Remover dos favoritos",
    "notTem": "Ainda não existe um modelo para esta categoria.",
    "create": "Criando arquivo, tente novamente mais tarde.",
    "openTips": "Abrindo arquivo, tente novamente mais tarde.",
    "mindmaster": "Uma ferramenta profissional de mapeamento mental entre plataformas",
    "mindmasterBtn": "Veja Agora",
    "search": "buscar",
    "noRes": "Desculpe, nenhum modelo encontrado"
  },
  "tw": {
    "new": "新建空白模板",
    "free": "免費",
    "vipFree": "會員免費",
    "newFile": "未命名檔案",
    "space": "雲端硬碟已達上限， 刪除檔案或清理回收站",
    "like": "已點讚",
    "cancelLike": "已取消點讚",
    "collect": "已收藏",
    "cancelCollect": "已取消收藏",
    "notTem": "該分類下暫時還沒有模板",
    "create": "正在建立檔案中，請稍後再試",
    "openTips": "正在打開檔案中，請稍後再試",
    "mindmaster": "一款更加專業的跨端心智圖工具",
    "mindmasterBtn": "立即訪問",
    "search": "搜尋",
    "noRes": "沒有找到相關模板",
    "report": "舉報"
  },
  "kr": {
    "new": "새 템플릿 만들기",
    "free": "무료",
    "vipFree": "회원 무료",
    "newFile": "이름 없는 파일",
    "space": "저장 공간이 부족합니다. 파일 삭제 또는 프리미엄 버전으로 업그레이드하여 더 많은 저장 공간을 획득하세요~",
    "like": "좋아요",
    "cancelLike": "좋아요 취소",
    "collect": "즐겨찾기",
    "cancelCollect": "즐겨찾기 취소",
    "notTem": "해당 분류에는 아직 템플릿이 없습니다",
    "create": "파일 생성중입니다,다시 시도해보세요~",
    "openTips": "파일 여는 중입니다. 다시 시도해보세요~",
    "mindmaster": "프로패셔널한 마인드 매핑 도구",
    "mindmasterBtn": "바로 확인하기",
    "search": "검색",
    "noRes": "관련 템플릿을 찾을 수 없습니다",
    "report": "신고"
  },
  "id": {
    "new": "Baru",
    "free": "Gratis",
    "vipFree": "VIP Gratis",
    "newFile": "File Tanpa Nama",
    "space": "Ruang penyimpanan tidak cukup. Hapus file atau tingkatkan ke versi premium untuk mengatasinya.",
    "like": "Disukai",
    "cancelLike": "Hapus Disukai",
    "collect": "Tambahkan ke Favorit",
    "cancelCollect": "Hapus dari Favorit",
    "notTem": "Belum ada templat untuk kategori ini.",
    "create": "Membuat file. Coba lagi nanti.",
    "openTips": "Membuka file. Coba lagi nanti.",
    "mindmaster": "Alat Pemetaan Pikiran Lintas Platform Profesional",
    "mindmasterBtn": "Lihat Sekarang",
    "search": "Cari",
    "noRes": "Maaf, templat tidak ditemukan"
  }
}
</i18n>
